import { render, staticRenderFns } from "./yhgl.vue?vue&type=template&id=2840084c&scoped=true&"
import script from "./yhgl.vue?vue&type=script&lang=js&"
export * from "./yhgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840084c",
  null
  
)

export default component.exports